<template>
  <v-dialog
    v-model="computedPatrolPermanentpostsVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <v-btn icon @click="methodToggleListView('patrol', 'permanentposts')">
          <v-icon>close</v-icon>
        </v-btn>

        <v-toolbar-title class="hidden-sm-and-down">Sign Lines</v-toolbar-title>
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <!-- padding to fix vuetify bug that should be fixed in 1.10 -->
        <v-select
          :items="select_mountain_items"
          v-model="select_mountain_model"
          style="padding-top:23px;"
        ></v-select>
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <v-text-field
          append-icon="search"
          single-line
          hide-details
          v-model="search"
          placeholder="Filter data"
        ></v-text-field>
        <v-spacer class="hidden-sm-and-down" />
        <v-menu
          bottom
          left
          v-if="
            computedAuthProfile === 'admin' ||
              computedAuthProfile === 'maintenance'
          "
        >
          <v-btn slot="activator" icon>
            <v-icon>get_app</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              @click.stop="
                methodDownloadKML(
                  $store.state.mapLayers.patrol.layers.permanentposts.geojson,
                  'post_num',
                  'patrol_permanentposts.kml'
                )
              "
            >
              <v-list-tile-title>KML</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :headers="headers"
          :items="computedPatrolPermanentpostsGeoJsonFeatures"
          :rows-per-page-items="rows_per_page"
          :rows-per-page-text="rows_per_page_text"
          :search="search"
          class="elevation-1"
          :loading="computedPatrolPermanentpostsLoading"
        >
          <template slot="items" slot-scope="props">
            <tr
              @click="
                signlineView = true;
                signlineViewSignline = props.item.sign_line;
              "
            >
              <td>{{ props.item.sign_line }}</td>
            </tr>
          </template>

          <!-- Alert when no results found -->
          <v-alert slot="no-results" :value="true" color="error" icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>

    <!-- signline view dialog -->
    <v-dialog
      v-model="signlineView"
      hide-overlay
      fullscreen
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn icon @click="signlineView = false">
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title>{{ signlineViewSignline }}</v-toolbar-title>
          <v-spacer class="hidden-sm-and-down"></v-spacer>
          <v-btn @click="addPost = true" color="info">Add Post</v-btn>
          <v-spacer class="hidden-sm-and-down"></v-spacer>
        </v-toolbar>
        <div
          style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
        >
          <v-data-table
            :headers="signlineViewHeaders"
            :items="computedPatrolPermanentpostsSignlineFeatures"
            :rows-per-page-items="rows_per_page"
            :rows-per-page-text="rows_per_page_text"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <tr
                @click="
                  methodToggleSingleLayer(
                    'patrol',
                    'permanentposts',
                    true,
                    props.item.properties.id
                  )
                "
              >
                <td v-if="props.item.properties.post_num != 666">
                  {{ props.item.properties.sign_line }} #{{
                    props.item.properties.post_num
                  }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <!-- Add Post -->
    <v-dialog
      v-model="addPost"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn
            icon
            @click="
              addPost = false;
              clearWatchLocation();
              lat = null;
              lng = null;
              accuracy = null;
              altitude = null;
              data_comments = null;
              data_trail_name = null;
              data_sign_loc = null;
            "
          >
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title class="hidden-sm-and-down">Add Post</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!tracking"
            :disabled="tracking"
            color="success"
            @click="geoWatchPosition()"
            >Start GPS</v-btn
          >
          <v-btn
            v-if="tracking"
            :disabled="!tracking"
            color="error"
            @click="clearWatchLocation()"
            >Stop GPS</v-btn
          >
          <v-spacer></v-spacer>
        </v-toolbar>
        <div
          style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
        >
          <v-data-table
            v-if="addPost"
            :items="addItemBlank"
            :hide-headers="addItemHideHeaders"
            :hide-actions="addItemHideActions"
          >
            <template slot="items">
              <tr>
                <td>Latitude</td>
                <td>
                  <span v-if="!lat && tracking">Getting latitude...</span>
                  {{ lat }}
                </td>
              </tr>
              <tr>
                <td>Longitude</td>
                <td>
                  <span v-if="!lng && tracking">Getting longitude...</span>
                  {{ lng }}
                </td>
              </tr>
              <tr>
                <td>Accuracy</td>
                <td>
                  <span v-if="!accuracy && tracking">Getting accuracy...</span>
                  {{ accuracy }}
                  <span v-if="accuracy">m</span>
                </td>
              </tr>
              <tr>
                <td>Altitude</td>
                <td>
                  <span v-if="!altitude && tracking">Getting altitude...</span>
                  {{ altitude }}
                  <span v-if="altitude">m</span>
                </td>
              </tr>
              <tr>
                <td>Mountain</td>
                <td>{{ computedAddMountain }}</td>
              </tr>
              <tr>
                <td>Post Number</td>
                <td>
                  <v-text-field v-model="data.post_num"></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Sign Line</td>
                <td>{{ signlineViewSignline }}</td>
              </tr>
              <tr>
                <td>Zone</td>
                <td>{{ computedAddZone }}</td>
              </tr>
              <tr>
                <td>Condition</td>
                <td>
                  <v-select
                    :items="opt_condition"
                    v-model="data.condition"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Purpose</td>
                <td>
                  <v-select
                    :items="opt_purpose"
                    v-model="data.purpose"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Sign</td>
                <td>
                  <v-select :items="opt_sign" v-model="data.sign"></v-select>
                </td>
              </tr>
              <tr>
                <td>Sign Type</td>
                <td>
                  <v-text-field v-model="data.sign_type"></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Rope</td>
                <td>
                  <v-select :items="opt_rope" v-model="data.rope"></v-select>
                </td>
              </tr>
              <tr>
                <td>Source</td>
                <td>
                  <v-select
                    :items="opt_source"
                    v-model="data.source"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Comments</td>
                <td>
                  <v-textarea v-model="data.comments"></v-textarea>
                </td>
              </tr>
              <tr>
                <td>Last edited</td>
                <td>{{ computedAuth.profile.email }}</td>
              </tr>
            </template>
            <template slot="footer">
              <tr>
                <td colspan="100%">
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                  <v-btn
                    @click.stop="
                      methodAddPatrolPermanentpostsGeoJson({
                        lat: lat,
                        lng: lng,
                        post_num: data.post_num,
                        zone: computedAddZone,
                        sign_line: signlineViewSignline,
                        condition: data.condition,
                        rope: data.rope,
                        mountain: computedAddMountain,
                        edit_by: computedAuth.profile.email,
                        source: data.source,
                        purpose: data.purpose,
                        sign: data.sign,
                        sign_type: data.sign_type,
                        comments: data.comments
                      });
                      clearWatchLocation();
                      methodClearPatrolPermanentpostsData();
                      lat = null;
                      lng = null;
                      accuracy = null;
                      altitude = null;
                      data = null;
                      methodGetPatrolPermanentpostsGeoJson();
                      addPost = false;
                    "
                    color="success"
                    >Save</v-btn
                  >
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
"dataPatrolPermanentposts";
export default {
  data() {
    return {
      addPost: false,
      lat: null,
      lng: null,
      accuracy: null,
      altitude: null,
      data: {
        post_num: "",
        zone: "",
        sign_line: "",
        condition: "",
        rope: "",
        montain: "",
        edit_by: "",
        source: "",
        purpose: "",
        sign: "",
        sign_type: "",
        comments: ""
      },
      addItemBlank: [""],
      addItemHideHeaders: true,
      addItemHideActions: true,
      watchId: null,
      tracking: false,
      addSign: false,
      signlineView: false,
      signlineViewSignline: "",
      signlineViewHeaders: [
        {
          text: "Posts",
          value: "properties.post_num"
        }
      ],
      select_mountain_items: ["Both Mountains", "Whistler", "Blackcomb"],
      select_mountain_model: "Both Mountains",
      loading: true,
      search: "",
      rows_per_page: [10, 25, 50, { text: "All", value: -1 }],
      rows_per_page_text: "Per page:",
      headers: [
        {
          text: "Sign Line",
          value: "sign_line"
        }
      ],
      opt_rope: [
        {
          text: "Yes",
          value: "yes"
        },
        {
          text: "No",
          value: "no"
        },
        {
          text: "Unknown",
          value: ""
        }
      ],
      opt_source: [
        { text: "CAD-GPS" },
        { text: "Phone" },
        { text: "Eye Ball" },
        { text: "Unknown" }
      ],
      opt_condition: [
        { text: "Good Condition" },
        { text: "Good Condition/ But Short" },
        { text: "Poor Condition/ Needs Replacement" },
        { text: "Buried" },
        { text: "Remove" },
        { text: "Miscellaneous" },
        { text: "Proposed" },
        { text: "Unknown" }
      ],
      opt_purpose: [
        { text: "Avalanche Closure" },
        { text: "Boundary" },
        { text: "Cliff" },
        { text: "Permanent Closure" },
        { text: "Gate" },
        { text: "Information Sign" },
        { text: "Unknown" }
      ],
      opt_sign: [
        {
          text: "Yes",
          value: "yes"
        },
        {
          text: "No",
          value: "no"
        },
        {
          text: "Unknown",
          value: ""
        }
      ]
    };
  },
  computed: {
    computedPatrolPermanentpostsSignlineFeatures() {
      if (
        this.$store.state.mapLayers.patrol.layers.permanentposts.geojson
          .features
      ) {
        const signline = this.$store.state.mapLayers.patrol.layers
          .permanentposts.geojson.features;
        const siteContents = signline.filter(
          item => item.properties.sign_line == this.signlineViewSignline
        );
        return siteContents;
      }
      return [];
    },
    computedAddZone() {
      const features = this.$store.state.mapLayers.patrol.layers.permanentposts
        .geojson.features;
      const zone = features.filter(
        item => item.properties.sign_line == this.signlineViewSignline
      );
      return zone[0].properties.zone;
    },
    computedAddMountain() {
      const features = this.$store.state.mapLayers.patrol.layers.permanentposts
        .geojson.features;
      const zone = features.filter(
        item => item.properties.sign_line == this.signlineViewSignline
      );
      return zone[0].properties.mountain;
    },
    computedPatrolPermanentpostsZoneFeatures() {
      if (
        this.$store.state.mapLayers.patrol.layers.permanentposts.geojson
          .features
      ) {
        const signline = this.$store.state.mapLayers.patrol.layers
          .permanentposts.geojson.features;
        const siteContents = signline.filter(
          item => item.properties.zone == this.signlineViewSignline
        );
        return siteContents;
      }
      return [];
    },
    computedPatrolPermanentpostsGeoJsonFeatures() {
      // chainable function to return only unique values of an array
      Array.prototype.unique = function() {
        return this.filter(function(value, index, self) {
          return self.indexOf(value) === index;
        });
      };
      if (
        this.$store.state.mapLayers.patrol.layers.permanentposts.geojson
          .features
      ) {
        const signlines = this.$store.state.mapLayers.patrol.layers
          .permanentposts.geojson.features;
        if (this.select_mountain_model == "Whistler") {
          const signlinesWhis = signlines.filter(
            item => item.properties.mountain == "Whistler"
          );

          let a = []; // blank array
          for (let i = 0; i < signlinesWhis.length; i++) {
            a.push(signlinesWhis[i].properties.sign_line); // push all sites into array a
          }

          let b = a.unique(); // 'filter' out duplicates

          let results = []; // blank array
          for (let i = 0; i < b.length; i++) {
            // loop through array b (unique sites)
            results.push({
              // push sites into json, "site": "some site here"
              sign_line: b[i]
            });
          }

          return results; // returns json with only unique sites
        } else if (this.select_mountain_model == "Blackcomb") {
          const signlines = this.$store.state.mapLayers.patrol.layers
            .permanentposts.geojson.features;
          const signlinesBlk = signlines.filter(
            item => item.properties.mountain == "Blackcomb"
          );

          let a = []; // blank array
          for (let i = 0; i < signlinesBlk.length; i++) {
            a.push(signlinesBlk[i].properties.sign_line); // push all sites into array a
          }
          let b = a.unique(); // 'filter' out duplicates

          let results = []; // blank array
          for (let i = 0; i < b.length; i++) {
            // loop through array b (unique sites)
            results.push({
              // push sites into json, "site": "some site here"
              sign_line: b[i]
            });
          }

          return results; // returns json with only unique sites
        } else if (this.select_mountain_model == "Both Mountains") {
          const signlinesBoth = this.$store.state.mapLayers.patrol.layers
            .permanentposts.geojson.features;

          let a = []; // blank array
          for (let i = 0; i < signlinesBoth.length; i++) {
            a.push(signlinesBoth[i].properties.sign_line); // push all sites into array a
          }

          let b = a.unique(); // 'filter' out duplicates

          let results = []; // blank array
          for (let i = 0; i < b.length; i++) {
            // loop through array b (unique sites)
            results.push({
              // push sites into json, "site": "some site here"
              sign_line: b[i]
            });
          }

          return results; // returns json with only unique sites
        }
      }
      return [];
    },
    computedPatrolPermanentpostsVisibility() {
      return this.$store.state.mapLayers.patrol.layers.permanentposts.visibility
        .listView;
    },
    computedPatrolPermanentpostsLoading() {
      return this.$store.state.mapLayers.patrol.layers.permanentposts.loading;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    geoSuccess(position) {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
      this.accuracy = position.coords.accuracy;
      this.altitude = position.coords.altitude;
    },
    geoError() {
      console.log("geo error");
    },
    geoWatchPosition() {
      let geoOptions = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      };
      this.tracking = true;
      this.watchId = navigator.geolocation.watchPosition(
        this.geoSuccess,
        this.geoError,
        geoOptions
      );
    },
    clearWatchLocation() {
      navigator.geolocation.clearWatch(this.watchId);
      this.tracking = false;
    },
    unique() {
      Array.prototype.unique = function() {
        return this.filter(function(value, index, self) {
          return self.indexOf(value) === index;
        });
      };
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      if (utcdate !== null) {
        return y + "-" + m + "-" + d;
      } else {
        return;
      }
    },
    // method to get geojson
    methodGetPatrolPermanentpostsGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/patrol/permanentposts",
        dept: "patrol",
        layer: "permanentposts",
        token: this.computedAuthToken
      });
    },
    methodAddPatrolPermanentpostsGeoJson(data) {
      let constFeature = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [data.lng, data.lat]
            },
            properties: {
              post_num: data.post_num,
              zone: data.zone,
              sign_line: data.sign_line,
              condition: data.condition,
              rope: data.rope,
              mountain: data.mountain,
              edit_by: data.edit_by,
              source: data.source,
              purpose: data.purpose,
              sign: data.sign,
              sign_type: data.sign_type,
              comments: data.comments
            }
          }
        ]
      };
      this.$store
        .dispatch("actionAddGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/patrol/permanentposts",
          dept: "patrol",
          layer: "permanentposts",
          token: this.computedAuthToken,
          payload: constFeature
        })
        .then(() => {
          this.methodGetPatrolPermanentpostsGeoJson();
        });
    }
  },
  methodClearPatrolPermanentpostsData() {
    this.data.post_num = null;
    this.data.zone = null;
    this.data.sign_line = null;
    this.data.condition = null;
    this.data.rope = null;
    this.data.mountain = null;
    this.data.edit_by = null;
    this.data.source = null;
    this.data.purpose = null;
    this.data.sign = null;
    this.data.sign_type = null;
    this.data.comments = null;
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.patrol.layers.permanentposts.visibility.listView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetPatrolPermanentpostsGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.patrol.layers.permanentposts.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
